// import React from "react";
// import Pagination from "../../helpers/Pagination";
// import { Eye } from "lucide-react";

// const formatDate = (date) => {
//   if (!date) return "-";

//   return new Date(date).toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// };

// const getStatusColor = (status) => {
//   switch (status) {
//     case "COMPLETED":
//       return "bg-green-100 text-green-700";

//     case "IN_PROGRESS":
//       return "bg-blue-100 text-blue-700";

//     case "PENDING":
//       return "bg-yellow-100 text-yellow-700";

//     case "ON_HOLD":
//       return "bg-orange-100 text-orange-700";

//     case "CANCELLED":
//       return "bg-red-100 text-red-700";

//     default:
//       return "bg-gray-100 text-gray-700";
//   }
// };

// const getTypeColor = (type) => {
//   switch (type) {
//     case "RECURRING":
//       return "bg-purple-100 text-purple-700";

//     case "ONE_TIME":
//       return "bg-gray-200 text-gray-700";

//     default:
//       return "bg-gray-100 text-gray-700";
//   }
// };

// export default function ClientListingTable({
//   data = [],

//   pagination,

//   onPageChange,

//   onItemsPerPageChange,

// }) {
//   return (
//     <div className="">

//       {/* Table */}

//       <div className="overflow-x-auto">

//         <table className="min-w-full border-separate border-spacing-y-2">

//           <thead>

//             <tr className="bg-red-100 text-sm">

//               <th className="px-4 py-4 rounded-l-lg">
//                 Client
//               </th>

//               <th className="px-4 py-4 text-left">
//                 Categories
//               </th>

//               <th className="px-4 py-4 text-left">
//                 Location
//               </th>

//               <th className="px-4 py-4 text-center">
//                 Progress
//               </th>

//               <th className="px-4 py-4 text-center">
//                 Completion
//               </th>

//               <th className="px-4 py-4 text-center">
//                 Status
//               </th>

//               <th className="px-4 py-4 text-center">
//                 Type
//               </th>

//               <th className="px-4 py-4 text-center">
//                 Handle By
//               </th>

//               <th className="px-4 py-4 text-center">
//                 Created By
//               </th>

//               <th className="px-4 py-4 text-center">
//                 Onboarding
//               </th>

//               {/* <th className="px-4 py-4 text-center">
//                 Created
//               </th> */}

//               <th className="px-4 py-4 rounded-r-lg">
//                 Action
//               </th>

//             </tr>

//           </thead>

//           <tbody>

//             {data.length > 0 ? (

//               data.map((row) => (

//                 <tr
//                   key={row._id}
//                   className="bg-gray-50 hover:bg-gray-100 shadow-sm text-sm"
//                 >

//                   {/* Client */}

//                   <td className="px-4 py-4">

//                     <div>

//                       <p className="font-semibold whitespace-nowrap">
//                         {row.clientId?.clientName}
//                       </p>

//                       <p className="text-xs text-gray-500 whitespace-nowrap">
//                         {row.clientId?.clientId}
//                       </p>

//                     </div>

//                   </td>

//                   {/* Categories */}

//                   <td className="px-4 py-4">

//                     <div className="flex flex-wrap gap-1">

//                       {row.clientCategories?.map((cat) => (

//                         <span
//                           key={cat}
//                           className="px-2 py-1 rounded-full bg-blue-100 text-blue-700 text-xs"
//                         >
//                           {cat}
//                         </span>

//                       ))}

//                     </div>

//                   </td>

//                   {/* Location */}

//                   <td className="px-4 py-4">

//                     {row.clientId?.state}

//                     <br />

//                     <span className="text-xs text-gray-500">
//                       {row.clientId?.country}
//                     </span>

//                   </td>
//                                     {/* Progress */}

//                   <td className="px-4 py-4 text-center">

//                     <div className="text-sm font-semibold">
//                       {row.completedItems} / {row.totalItems}
//                     </div>

//                     <div className="mt-2 w-36 mx-auto h-2 bg-gray-200 rounded-full overflow-hidden">

//                       <div
//                         className="h-full bg-green-500 rounded-full"
//                         style={{
//                           width: `${row.completionPercentage || 0}%`,
//                         }}
//                       />

//                     </div>

//                   </td>

//                   {/* Completion */}

//                   <td className="px-4 py-4 text-center font-semibold">

//                     {(row.completionPercentage || 0).toFixed(2)}%

//                   </td>

//                   {/* Status */}

//                   <td className="px-4 py-4 text-center">

//                     <span
//                       className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(
//                         row.onboardingStatus
//                       )}`}
//                     >
//                       {row.onboardingStatus?.replaceAll("_", " ")}
//                     </span>

//                   </td>

//                   {/* Client Type */}

//                   <td className="px-4 py-4 text-center">

//                     <span
//                       className={`px-3 py-1 rounded-full text-xs font-medium ${getTypeColor(
//                         row.clientType
//                       )}`}
//                     >
//                       {row.clientType || "-"}
//                     </span>

//                   </td>

//                   {/* Handle By */}

//                   <td className="px-4 py-4 text-center whitespace-nowrap">

//                     <div>

//                       <p className="font-semibold whitespace-nowrap">
//                         {row.handleBy
//                       ? `${row.handleBy.firstName} ${row.handleBy.lastName}`
//                       : "-"}
//                       </p>

//                       <p className="text-xs text-gray-500 whitespace-nowrap">
//                         {row.handleBy?.userId}
//                       </p>

//                     </div>
//                   </td>

//                   {/* Created By */}

//                   <td className="px-4 py-4 text-center whitespace-nowrap">


//                     <div>

//                       <p className="font-semibold whitespace-nowrap">
//                       {row.createdBy
//                       ? `${row.createdBy.firstName} ${row.createdBy.lastName}`
//                       : "-"}
//                       </p>

//                       <p className="text-xs text-gray-500 whitespace-nowrap">
//                         {row.createdBy?.userId}
//                       </p>

//                     </div>
//                   </td>

//                   {/* Onboarding Date */}

//                   <td className="px-4 py-4 text-center whitespace-nowrap">

//                     {formatDate(row.clientOnboardingDate)}

//                   </td>

//                   {/* Created Date */}

//                   {/* <td className="px-4 py-4 text-center whitespace-nowrap">

//                     {formatDate(row.createdAt)}

//                   </td> */}

//                   {/* Action */}

//                   <td className="px-4 py-4 text-center">

//                     <button
//                       className="w-9 h-9 rounded-lg bg-blue-100 hover:bg-blue-200 flex items-center justify-center mx-auto transition"
//                     >
//                       <Eye size={18} className="text-blue-700" />
//                     </button>

//                   </td>

//                 </tr>

//               ))

//             ) : (

//               <tr>

//                 <td
//                   colSpan={12}
//                   className="py-10 text-center text-gray-500"
//                 >
//                   No Clients Found
//                 </td>

//               </tr>

//             )}

//           </tbody>

//         </table>

//       </div>

//       {/* Pagination */}

//       {pagination?.total > 0 && (

//         <div className="p-4">

//           <Pagination
//             totalItems={pagination.total}
//             itemsPerPage={pagination.limit}
//             currentPage={pagination.page}
//             onPageChange={onPageChange}
//             onItemsPerPageChange={onItemsPerPageChange}
//           />

//         </div>

//       )}

//     </div>

//   );

// }

import React from "react";

import { Eye } from "lucide-react";
import ModernTable from "../ui/ModernTable";

// Helper Functions
const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const getStatusColor = (status) => {
  switch (status) {
    case "COMPLETED": return "bg-green-100 text-green-700";
    case "IN_PROGRESS": return "bg-blue-100 text-blue-700";
    case "PENDING": return "bg-yellow-100 text-yellow-700";
    case "ON_HOLD": return "bg-orange-100 text-orange-700";
    case "CANCELLED": return "bg-red-100 text-red-700";
    default: return "bg-gray-100 text-gray-700";
  }
};

const getTypeColor = (type) => {
  switch (type) {
    case "RECURRING": return "bg-purple-100 text-purple-700";
    case "ONE_TIME": return "bg-gray-200 text-gray-700";
    default: return "bg-gray-100 text-gray-700";
  }
};

export default function ClientListingTable({
  data = [],
  pagination,
  onPageChange,
  onItemsPerPageChange,
}) {
  
  // ModernTable Column Definitions
  const columns = [
    {
      label: "Client",
      key: "client",
      render: (row) => (
        <div>
          <p className="font-semibold text-gray-900">{row.clientId?.clientName || "-"}</p>
          <p className="text-xs text-gray-500">{row.clientId?.clientId || "-"}</p>
        </div>
      ),
    },
    {
      label: "Categories",
      key: "clientCategories",
      render: (row) => (
        <div className="flex flex-wrap gap-1">
          {row.clientCategories?.map((cat) => (
            <span key={cat} className="px-2 py-0.5 rounded-full bg-blue-50 text-blue-600 text-[10px] font-medium border border-blue-100">
              {cat}
            </span>
          ))}
        </div>
      ),
    },
    {
      label: "Location",
      key: "location",
      render: (row) => (
        <div className="text-xs">
          <p className="font-medium">{row.clientId?.state || "-"}</p>
          <p className="text-gray-500">{row.clientId?.country || "-"}</p>
        </div>
      ),
    },
    {
      label: "Progress",
      key: "progress",
      headerAlign: "center",
      render: (row) => (
        <div className="w-full max-w-[120px] mx-auto">
          <div className="flex justify-between text-[10px] mb-1 font-medium">
            <span>{row.completedItems} / {row.totalItems}</span>
          </div>
          <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-green-500 rounded-full"
              style={{ width: `${row.completionPercentage || 0}%` }}
            />
          </div>
        </div>
      ),
    },
    {
      label: "Completion",
      key: "completionPercentage",
      headerAlign: "center",
      render: (row) => (
        <span className="font-semibold text-gray-700">
          {(row.completionPercentage || 0).toFixed(2)}%
        </span>
      ),
    },
    {
      label: "Status",
      key: "onboardingStatus",
      headerAlign: "center",
      render: (row) => (
        <span className={`px-2.5 py-1 rounded-full text-[11px] font-semibold ${getStatusColor(row.onboardingStatus)}`}>
          {row.onboardingStatus?.replaceAll("_", " ")}
        </span>
      ),
    },
    {
      label: "Type",
      key: "clientType",
      headerAlign: "center",
      render: (row) => (
        <span className={`px-2.5 py-1 rounded-full text-[11px] font-semibold ${getTypeColor(row.clientType)}`}>
          {row.clientType || "-"}
        </span>
      ),
    },
    {
      label: "Handle By",
      key: "handleBy",
      render: (row) => (
        <div>
          <p className="font-medium text-gray-800">
            {row.handleBy ? `${row.handleBy.firstName} ${row.handleBy.lastName}` : "-"}
          </p>
          <p className="text-[10px] text-gray-500">{row.handleBy?.userId || ""}</p>
        </div>
      ),
    },
    {
      label: "Onboarding",
      key: "clientOnboardingDate",
      headerAlign: "center",
      render: (row) => formatDate(row.clientOnboardingDate),
    },
  ];

  // ModernTable-க்கான Action Definition
  const actions = [
    {
      label: "View",
      render: (row) => (
        <button
          onClick={() => console.log("View Row:", row._id)}
          className="w-8 h-8 rounded-lg bg-blue-50 hover:bg-blue-100 flex items-center justify-center transition ml-auto"
        >
          <Eye size={16} className="text-blue-600" />
        </button>
      ),
    },
  ];

  return (
    <div className="mt-4">
      <ModernTable
        columns={columns}
        data={data}
        actions={actions}
        selectable={false} // if need change to true
        actionType="button"
        stickyColumns={1} // Client - sticky column
        pagination={{
          totalItems: pagination.total,
          itemsPerPage: pagination.limit,
          currentPage: pagination.page,
          onPageChange: onPageChange,
          onItemsPerPageChange: onItemsPerPageChange,
        }}
      />
    </div>
  );
}